import { mapActions } from 'vuex';
import domainMixin from '../../../mixins/domain';

export default {
  mixins: [domainMixin],
  data() {
    return {
      ruleForm: {
        code: '',
        contractNumber: '',
        eic: '',
        name: '',
        email: '',
        password: '',
      },
      rules: {
        code: [
          {
            required: true,
            message: "Це поле є обов'язковим",
          },
          {
            min: 8,
            max: 12,
            message: 'Довжина цього поля повина бути від 8 до 12 символів',
            trigger: 'blur',
          },
        ],
        contractNumber: [
          {
            required: true,
            message: "Номер договору є обов'язковим",
          },
        ],
        eic: [
          {
            required: true,
            message: "EIC-код є обов'язковим для реєстрації",
            trigger: 'blur',
          },
          {
            min: 16,
            max: 16,
            message: 'EIC-код повинен складатись рівно з 16 символів',
            trigger: 'blur',
          },
          {
            pattern: /^56X[A-Z0-9]{13}$/i,
            message: 'EIC-код повинен починатись із 56X (наприклад, 56XS00008GCQJ00U)',
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: "Назва контрагенту є обов'язковою" }],
        email: [{ required: true, message: 'Електрона пошта є обовязковою' }],
        password: [
          {
            required: true,
            min: 6,
            message: 'Довжина паролю повина бути від 6 символів',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions(['register']),
    handleEicInput(val) {
      if (val) {
        this.ruleForm.eic = val.toUpperCase().replace(/\s/g, '');
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.register(this.ruleForm)
            .then(() => {
              this.$router.push('/login');
            })
            .catch((error) => {
              this.$notify.error({
                title: 'Error',
                message: error.response.data,
              });
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
